/* Where this app is published — the domain that belongs in a link somebody
   else will open (a copied profile link, a media-kit share URL).
 *
 * It is deliberately its own variable rather than being derived:
 *  - `REACT_APP_API_URL` is the backend host, which is a different machine in
 *    every deployment we have and is `http://localhost` in dev.
 *  - `window.location.origin` is `http://localhost` inside the Capacitor
 *    shell, so a link copied from the mobile app would open nothing.
 *
 * Set `REACT_APP_SITE_URL` per environment. The origin fallback only keeps
 * the web build honest when it is unset; it is not a substitute on mobile.
 */

const configured = (process.env.REACT_APP_SITE_URL || '').trim();

const fallback =
    typeof window !== 'undefined' && window.location ? window.location.origin : '';

const withScheme = (value) =>
    !value || /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`;

/** Absolute origin, no trailing slash: `https://chatliy.com`. */
export const SITE_URL = withScheme(configured || fallback).replace(/\/+$/, '');

/** Host only, for printing a link the user reads rather than clicks. */
export const SITE_HOST = SITE_URL.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '');

/** Absolute URL for an in-app path. */
export const siteUrl = (path = '') =>
    `${SITE_URL}/${String(path).replace(/^\/+/, '')}`;

/** The public profile link for a username, as shared. */
export const publicProfileUrl = (username) => siteUrl(username);

/** The same link without the scheme, for display next to a copy button. */
export const publicProfileLabel = (username) => `${SITE_HOST}/${username}`;

/** The press page, optionally carrying a share token. */
export const mediaKitUrl = (username, token) =>
    `${siteUrl(`${username}/media-kit`)}${token ? `?token=${token}` : ''}`;
